<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2025-11-11 09:35:12
 * @LastEditors: sjq
 * @LastEditTime: 2026-07-09 12:17:32
 -->
<template>
  <div class="container">
    <app-header class="header" :title="title" back-type="back-app" />
    <div class="content_box">
      <section class="sec">
        <h3 class="sec-title">积分是什么？</h3>
        <p>积分是友邻少年APP给孩子的虚拟奖励。</p>
      </section>

      <section class="sec">
        <h3 class="sec-title">积分有什么用途？</h3>
        <p>获得积分后，可以在"积分商城"中兑换礼品。</p>
      </section>

      <section class="sec">
        <h3 class="sec-title">积分如何获得？</h3>
        <ol class="num">
          <li>
            1. 完成学习任务
            <ul class="dot">
              <li class="dot-style">
                每天学习时长≥20分钟，即可获得10积分（每天获取上限10积分）。
                （仅统计【文章讲解】【听力磨耳】【口语练习】等模块学习时长，多个模块学习时长累积计算；【口语练习】中仅统计当天在APP中录音总时长）
              </li>
            </ul>
          </li>
          <!-- <li>
            2. 参加活动
            <ul class="dot">
              <li class="dot-style">邀请一位好友报名体验营，可获得200积分，多邀多得，上不封顶。</li>
            </ul>
          </li> -->
        </ol>
      </section>

      <section class="sec">
        <h3 class="sec-title">积分有效期是多久？</h3>
        <p>APP内的积分不限制有效期，您所获得的积分将永久有效，可随时积累并根据您的需求进行使用。</p>
      </section>

      <section class="sec">
        <h3 class="sec-title">积分可以提现吗？</h3>
        <p>不可以，积分仅限在友邻少年积分商城中兑换礼品。</p>
      </section>

      <section class="sec">
        <h3 class="sec-title">积分商城兑换礼品后，支持退换货吗？</h3>
        <p>
          礼品兑换成功后，若非质量问题，暂不支持退货，挑选礼品时，请认真确认哦！如遇质量问题，可联系班主任老师提供图片说明，核实后进行补发处理。
        </p>
      </section>

      <section class="sec">
        <h3 class="sec-title">常见问题</h3>
        <ol class="num faq-list">
          <li>
            1）积分何时到账？
            <p class="dot-style">
              在完成相应任务后，积分通常会在10分钟内自动到账。如遇延迟，请尝试刷新页面，或联系平台客服进行处理。
            </p>
          </li>
          <li>
            2）已完成任务但未获得积分怎么办？
            <p class="dot-style">
              请确认是否符合获取积分的条件，如确认无误仍未获取积分，请联系平台客服，我们将协助您处理。
            </p>
          </li>
          <li>
            3）兑换礼品何时发货？
            <p class="dot-style">
              礼品兑换成功后，正常情况将于15个工作日内发货，如遇节假日、极端天气、缺货等特殊原因会有延迟。
            </p>
          </li>
          <li>
            4）因系统升级、功能删减、活动变化、礼品库存等影响，以上积分获取方式及使用方式，友邻少年将根据实际情况进行调整更新，具体以积分商城页面显示为准。
          </li>
        </ol>
      </section>
      <section class="sec">
        <div class="tip">
          积分商城规则的最终解释权归友邻少年所有。
          <br />
          如果您对积分商城有任何问题，可以联系班主任或拨打客服电话进行反馈。
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: '积分规则',
      imgUrl: 'https://img-cdn1.ylyk.com/image/1661148956552_m1661148869726_s269159.jpg'
    }
  }
}
</script>

<style lang="less" scoped>
.content_box {
  padding: 0.16rem 0.24rem 0.4rem;

  .sec + .sec {
    margin-top: 0.32rem;
  }

  .sec-title {
    margin: 0.12rem 0 0.24rem; /* 标题与正文间距提升到 ~24px */
    font-size: 0.32rem; /* ~16px */
    font-weight: 600;
    line-height: 1.3;
    color: #000; /* 标题文字保持黑色 */
    position: relative;
    padding-left: 0.3rem;
  }

  .sec-title::before {
    content: '▎';
    position: absolute;
    left: 0;
    color: #00b25a; /* 符号使用品牌绿色 */
  }

  /* 正文与通用段落 */
  p {
    margin: 0.12rem 0;
    line-height: 1.8;
    font-size: 0.3rem; /* ~15px */
    color: #666; /* 文案 66 灰 */
  }

  .tip {
    margin-top: 0.16rem;
    font-size: 0.26rem;
    color: #666;
    line-height: 1.7;
  }

  /* 数字列表：用于“积分规则”“常见问题” */
  .num {
    list-style: decimal;
    padding: 0;

    > li {
      margin: 0.16rem 0; /* 列表项间距加大 */
      line-height: 1.7;

      /* 子段落与子列表的额外间距 */
      > p {
        margin-top: 0.08rem;
      }
    }
  }

  /* 统一列表项样式 */
  .faq-list p,
  .dot > li {
    position: relative;
    padding-left: 0.2rem;
    margin: 0.1rem 0; /* 间距微调 */
    line-height: 1.8;
    font-size: 0.3rem; /* ~15px */
    color: #666;
  }

  .faq-list p::before,
  .dot > li::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0.72em;
    width: 0.1rem;
    height: 0.1rem;
    border-radius: 50%;
    background-color: #00b25a; /* 圆点用品牌绿 */
  }

  .faq-list {
    list-style: none;
    margin-left: 0;
    padding: 0;

    p {
      position: relative;
      padding-left: 0.2rem;
    }
  }

  /* 圆点子列表：用于“完成学习任务/参加活动”下的条目 */
  .dot {
    list-style: none;
    margin: 0.08rem 0 0.08rem 0.24rem;
    padding: 0;

    > li {
      position: relative;
      padding-left: 0.2rem;
      margin: 0.1rem 0; /* 间距微调 */
      line-height: 1.8;
      font-size: 0.3rem;
      color: #666;
    }
  }

  img {
    width: 100%;
    display: block;
  }
}
</style>
